import task_status_data from "libs/task_status_data.json";

const NotificationRender = (template, context, t) => {
  switch (template) {
    case 1:
      return {
        text: t("A new invoice is available"),
      };
    case 2:
      return {
        text: t(`Card payment was declined`),
      };
    case 3:
      return {
        text: t(`Payment method expires in 30 days`),
      };
    case 4:
      return {
        text: t(`Payment method expires in 14 days`),
      };
    case 5:
      return {
        text: t(`Payment method expires in 7 days`),
      };
    case 6:
      return {
        text: t(`Payment method expires in 3 days`),
      };
    case 7:
      return {
        text: t(`Payment method expires in 2 days`),
      };
    case 8:
      return {
        text: t(`Payment method expires in 1 day`),
      };
    case 9:
      return {
        text: t(`Content Management System update completed`),
      };
    case 10:
      return {
        text: t(`SSL Certificate expires in 7 days`),
      };
    case 11:
      return {
        text: t(`SSL Certificate expires in 1 day`),
      };
    case 12:
      return {
        text: t(`Domain expires in 7 days`),
      };
    case 13:
      return {
        text: t(`Domain expires in 1 day`),
      };
    case 14:
      return {
        text: t(`Finish Your Webinity Subscription Purchase`),
      };
    case 15:
      return {
        text: t(`Your subscription has been successfully cancelled`),
      };
    case 16:
      return {
        text: t(`Subscription has been cancelled`),
      };
    case 17:
      return {
        text: t(`You have created a new task`),
      };
    case 18:
      return {
        text: t(`Client created a new task`),
      };
    case 19:
      return {
        color: "#00FEFF",
        text: t(`New comment`),
        label: t(`New comment`),
      };
    case 20:
      return {
        color: "#FFEB00",
        text: `${t("Status of the task")} “<u>${context?.task_name}</u>” ${t(
          "has been changed to"
        )} <strong>${t(
          task_status_data.find((status) => status.value === context?.status)
            ?.label
        )}</strong>`,
        label: t(`Change of status`),
      };
    case 21:
      return {
        text: t(`Task assigned to you`),
      };
    case 23:
      return {
        text: t(`Development time available in your plan has been exceeded`),
      };
    case 24:
      return {
        text: t(`New subscription has been successfully purchased`),
      };
    case 25:
      return {
        text: t(`Your password has been successfully reset`),
      };
    case 26:
      return {
        text: t(`Your subscription plan has been changed`),
      };
    case 27:
      return {
        text: t(`Subscription plan has been changed`),
      };
    case 28:
      return {
        text: t(`New user registered`),
      };
    default:
      return "";
  }
};

export const isNewTaskNotification = (template) =>
  template === 17 || template === 18;

export const getNotificationTitle = ({ template, context, task }, t) => {
  const notification = NotificationRender(template, context, t);
  const isNewTask = isNewTaskNotification(template);
  let title;

  if (isNewTask) {
    title = notification.text;
  } else if (template === 19 || template === 20 || template === 21) {
    title = notification.label || notification.text;
  } else {
    title = t(template === 28 ? "New registration" : "New notification");
  }

  return isNewTask && task?.title ? `${title} - ${task.title}` : title;
};

export default NotificationRender;
